import React from 'react';
import { Flex, Text, Stack, Image, Box,
  Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon
 } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import chBanner from '../Resources/Images/Banners/FAQ_banner_BG.png';
import CenterGuideBrick from '../Components/Common/CenterGuideBrick';
import BannerBar from '../Components/Common/BannerBar';

type AccordionType = {
  content: { question: string, answer: string },
  index: number
};

const FAQPage4: React.FC = () => {
  const { t, i18n } = useTranslation();
  const tbuaFAQ: any[] = t('tbuaCertificateFAQ');
  const taicaFAQ: any[] = t('taicaCertificateFAQ');
  const TeacherAccordion: React.FC<AccordionType> = ({content, index}) => 
    <AccordionItem py='6px' color='text.main' borderBottom='none'>
      <AccordionButton>
        <Text as='span' flex='1' textAlign='left' textStyle='semibold_lg'>
          Q{index + 1}{i18n.language === 'zh' ? '：' : ': '}{content['question']}
        </Text>
        <AccordionIcon boxSize='24px' color='primary.light' />
      </AccordionButton>
      <AccordionPanel pb={4} textStyle='normal_md'>
        A{i18n.language === 'zh' ? '：' : ': '}
        {content['answer'].split('\n').map((ans: string, idx: number) =>
          <Flex key={idx} color='primary.dark' textStyle='normal_md' pl={/^[a-z]\./.test(ans) ? '20px' : '0'}>
            {/^[a-zA-Z0-9]\./.test(ans) ?
              <React.Fragment>
                <Box>{ans.split('\.')[0]}.&nbsp;</Box>
                <Box>{ans.substring(3)}</Box>
              </React.Fragment> :
              <Box>{ans}</Box>
            }
          </Flex>
          
        )}
      </AccordionPanel>
    </AccordionItem>;

  return (
    <Stack w='100%' minH='84vh' direction='column' align='center'>
      {/*<Image w='100%' maxH='301px' objectFit='cover' src={i18n.language === 'zh' ? chBanner : enBanner} alt='教育部標章'/>*/}
      {BannerBar(t('banner.FAQ4'), chBanner)}
      <Flex w='85%' h='100%' py='32px' direction='column'>
        <CenterGuideBrick/>
              <Text id="tbua" mb='30px' fontSize='24px' fontWeight='700' lineHeight='133%' letterSpacing='0.24px' color='white'>
                {"TBUA-anchor"}
              </Text>
              <Text mt='44px' mb='24px' fontSize='24px' fontWeight='700' lineHeight='133%' letterSpacing='0.24px' color='primary.light'>
                {t('certCategory.tbua')}
              </Text>
              <Accordion allowMultiple allowToggle>
                {tbuaFAQ.map((content: any, index: number) =>
                  <TeacherAccordion key={index} content={content} index={index} />
                )}
              </Accordion>
              <Text id="taica" mb='30px' fontSize='24px' fontWeight='700' lineHeight='133%' letterSpacing='0.24px' color='white'>
                {"TAICA-anchor"}
              </Text>
              <Text mb='24px' fontSize='24px' fontWeight='700' lineHeight='133%' letterSpacing='0.24px' color='primary.light'>
                {t('certCategory.taica')}
              </Text>
              <Accordion allowMultiple allowToggle>
                {taicaFAQ.map((content: any, index: number) =>
                  <TeacherAccordion key={index} content={content} index={index} />
                )}
              </Accordion>
      </Flex>
    </Stack>
  )
};

export default FAQPage4;
